import {
  RegionsFrance,
  RegionsOutreMer,
  RegionsWorld,
} from '@captaincause/types'
import { tm } from '../tm'
import { Map } from './Map'
import i18n from './i18n'
import type { CSSProperties } from 'react'
import type {
  Locales,
  Project,
  RegionFrance,
  RegionOutreMer,
  RegionWorld,
} from '@captaincause/types'

interface ProjectRegionProps {
  project: Project
  className?: string
  titleClassName?: string
  mapClassName?: string
  style?: CSSProperties
  locale: Locales
}

const emptyObject = {}
export function ProjectRegion({
  project,
  className = '',
  titleClassName = undefined,
  mapClassName = undefined,
  style = emptyObject,
  locale,
}: ProjectRegionProps) {
  if (!project.region_tags || project.region_tags.length === 0) return null

  const t = i18n[locale]

  const allRegions = project.region_tags.filter(Boolean)

  const franceRegions = allRegions.filter((region): region is RegionFrance =>
    RegionsFrance.some(franceRegion => franceRegion === region),
  )

  const worldRegions = allRegions.filter((region): region is RegionWorld =>
    RegionsWorld.some(worldRegion => worldRegion === region),
  )

  const outreMerRegions = allRegions.filter(
    (region): region is RegionOutreMer =>
      RegionsOutreMer.some(outerMerRegion => outerMerRegion === region),
  )

  const hasMoreThan6Regions = allRegions.length > 6

  const tresholdGroupFranceRegions = () => {
    if (outreMerRegions.length === 0 && worldRegions.length === 0) {
      return 6
    }

    if (outreMerRegions.length === 0 && worldRegions.length > 0) {
      return 4
    }

    if (outreMerRegions.length > 0 && worldRegions.length === 0) {
      return 5
    }

    return 3
  }

  return (
    <div className={className} style={style}>
      <div className={tm('mb-4 text-dark-gray', titleClassName)}>{t.title}</div>
      <div className="flex flex-wrap gap-x-5 gap-y-4">
        {hasMoreThan6Regions ? (
          <>
            <Map
              type="france"
              highlight={franceRegions}
              label="France"
              className={mapClassName}
              locale={locale}
            />
            <Map
              type="outreMer"
              highlight={outreMerRegions}
              label="Outre-Mer"
              className={mapClassName}
              locale={locale}
            />
            <Map
              type="international"
              highlight={worldRegions}
              label="International"
              className={mapClassName}
              locale={locale}
            />
          </>
        ) : (
          <>
            {franceRegions.length > tresholdGroupFranceRegions() ? (
              <Map
                type="france"
                highlight={franceRegions}
                label="France"
                className={mapClassName}
                locale={locale}
              />
            ) : (
              franceRegions.map(region => (
                <Map
                  key={region}
                  type="france"
                  highlight={[region]}
                  label={region}
                  className={mapClassName}
                  locale={locale}
                />
              ))
            )}
            <Map
              type="outreMer"
              highlight={outreMerRegions}
              label={
                outreMerRegions.length > 1 ? 'Outre-Mer' : outreMerRegions[0]
              }
              className={mapClassName}
              locale={locale}
            />
            <Map
              type="international"
              highlight={worldRegions}
              label={
                worldRegions.length > 1 ? 'International' : worldRegions[0]
              }
              className={mapClassName}
              locale={locale}
            />
          </>
        )}
      </div>
    </div>
  )
}
